import React from 'react';
import {addElement} from '../../../actions/CreateSiteActions/createSiteActions'
import { connect } from 'react-redux';
import {ADD_EXTERNALCOLLABORATION} from "../../../actions/types";
import {ChoiceGroup} from '@fluentui/react';
import Warning from "../CommonComponents/Warning";



class ExternalCollaboration extends React.Component {

    onSelectOption (e,v)
    {
        const selected = v.key;
    //    this.props.updateValidationStatus(SET_EXTERNAL_VALID,{isValid:true,message:""})
        this.props.sendElement(ADD_EXTERNALCOLLABORATION, selected)
    }

    getSelectedKey() {
        return this.props.onPremise 
                ? false 
                : (this.props.isMsTeams ? true : this.props.external);
    }   

    render() {
        if(!this.props.confidentiality) return null;
        const warn = this.props.possibleWarning && this.props.external === null ? <Warning/> : null;
        const error = warn && <div className='errorMessage'>Please select an option</div>;
        const info = this.props.isMsTeams && <div className='infoMessage'>External sharing is enabled on every MS Team</div>;

        const render =  <div className='externalCollaboration'>
            <label>
                <div className='item-title' style={{ paddingBottom: '10px'}}>Will external users (people without an ABB email address) need access to your SharePoint site? (e.g., for sharing documents with a customer){warn}</div>
                <ChoiceGroup
					id='choice-External'
                    selectedKey={this.getSelectedKey()}
                    disabled= {this.props.onPremise || this.props.isMsTeams}
                    options={[
                        {
                            key: true,
                            text: 'Yes',
                            'data-automation-id': 'auto1',
							className: 'radio-External'
                        },
                        {
                            key: false,
                            text: 'No',
							className: 'radio-External'
                        }
                    ]}
                    required={true}
                    onChange={this.onSelectOption.bind(this)}
                />
            </label>
            {error}
            {info}
        </div>
        return (
            <div className='wizard-inside'>
                {render}
            </div>
        );
    }
}

const mapStateToProps  = state => ({
    confidentiality: state.newSite.Confidentiality,
    external: state.newSite.ExternalCollaboration,
    onPremise: state.newSite.OnPremiseState,
    possibleWarning : state.wizard.nextStepRequested,
    isMsTeams: state.newSite.isMsTeams
  //  validationResult : state.step1Validation.ExternalValid
})

const mapActionsToProps = {
    sendElement : addElement,
 //   updateValidationStatus : updateValidationStatus
}

export default connect(mapStateToProps,mapActionsToProps)(ExternalCollaboration);




// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/ExternalCollaboration.js